<template>
	<div class="d-flex flex-row align-center">
		<v-text-field
			label="名称"
			v-model="form.name"
			class="mr-1"
			style="max-width: 20rem"
			:error-messages="errors.name"
		></v-text-field>
		<v-text-field
			label="编码"
			v-model="form.code"
			style="max-width: 20rem"
			:error-messages="errors.code"
		></v-text-field>
	</div>
	<div class="d-flex mb-2 flex-row align-center justify-start flex-wrap">
		类型：
		<v-radio-group v-model="form.type" inline>
			<v-radio
				v-for="item in refs['SupplierType']"
				:key="item.value"
				:label="item.title"
				:error-messages="errors.type"
				:value="item.value"
			></v-radio>
		</v-radio-group>
	</div>
	<div class="d-flex flex-wrap">
		<v-text-field
			label="联系人"
			v-model="form.contact"
			style="max-width: 20rem; width: 10rem"
			class="mr-1"
			:error-messages="errors.contact"
		></v-text-field>

		<v-text-field
			label="电话"
			style="max-width: 20rem; width: 10rem"
			v-model="form.tel"
			class="mr-1"
			:error-messages="errors.tel"
		></v-text-field>
		<v-text-field
			label="地址"
			style="max-width: 20rem; width: 10rem"
			v-model="form.address"
			class="mr-1"
			:error-messages="errors.address"
		></v-text-field>
		<v-text-field
			label="网址"
			style="max-width: 24rem; min-width: 14rem"
			v-model="form.website"
			:error-messages="errors.website"
			placeholder="https://"
		></v-text-field>
	</div>
	<div class="d-flex flex-wrap align-center justify-start">
		状态：
		<v-radio-group v-model="form.status" inline dense hide-details="auto">
			<v-radio
				v-for="item in refs['SupplierStatus']"
				:key="item.value"
				:label="item.title"
				:error-messages="errors.status"
				:value="item.value"
			></v-radio>
		</v-radio-group>
	</div>

	<div class="mt-2">
		<div class="d-flex align-center mb-1">
			<span class="mr-2">证照图片</span>
			<image-uploader label="图片" model-value="" @uploaded="onCertUploaded">
				<template #default="{ trigger, progress }">
					<v-btn size="small" @click="trigger">上传营业执照/资质证明</v-btn>
					<v-progress-linear
						v-if="progress > 0 && progress < 100"
						:model-value="progress"
						color="blue"
						height="6"
						class="mt-1"
						style="max-width: 12rem"
					></v-progress-linear>
				</template>
			</image-uploader>
		</div>
		<div class="d-flex flex-wrap">
			<div v-for="(item, idx) in form.certificates" :key="item" class="mr-2 mb-2 text-center">
				<v-img
					:src="item"
					contain
					width="100"
					height="100"
					class="grey-lighten-2"
					@click="showImg(item)"
				/>
				<v-btn size="x-small" variant="text" color="error" @click="removeCert(idx)">
					<v-icon size="small">mdi-trash-can</v-icon>
				</v-btn>
			</div>
		</div>
	</div>

	<div class="d-flex flex-row align-center mt-2">
		<v-textarea v-model="form.description" label="备注" :error-messages="errors.description" rows="2"></v-textarea>
	</div>
	<slot name="actions" :object="form"></slot>

	<v-dialog v-model="popupDlg" width="80%">
		<v-img :src="popupUrl" contain style="max-height: 80vh" />
	</v-dialog>
</template>

<script>
import { clone } from 'lodash-es'
import ImageUploader from '../common/ImageUploader.vue'

export default {
	components: { ImageUploader },
	props: {
		value: Object,
		errors: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			form: { certificates: [] },
			refs: {},
			loading: false,
			popupDlg: false,
			popupUrl: null
		}
	},
	mounted() {
		this.syncForm(this.value)
		this.$api.common.meta('supplier', 'SupplierType,SupplierStatus', (res) => {
			this.refs = res
		})
	},
	watch: {
		value: {
			handler(val) {
				this.syncForm(val)
			},
			immediate: true
		}
	},
	methods: {
		syncForm(val) {
			this.form = clone(val || {})
			if (!this.form.certificates) this.form.certificates = []
		},
		showImg(url) {
			this.popupDlg = true
			this.popupUrl = url
		},
		onCertUploaded(urls) {
			if (!this.form.certificates) this.form.certificates = []
			this.form.certificates.push(urls[0])
		},
		removeCert(idx) {
			this.$confirm('确定删除该图片?').then((r) => {
				if (r) this.form.certificates.splice(idx, 1)
			})
		},
		submitForm() {
			if (this.form['owner'] == 'other') {
				this.form['owner'] = this.form['otherOwner']
				delete this.form['otherOwner']
			}
			this.$emit('submit', this.form)
		}
	}
}
</script>
